import { render } from "./RegisterPage.vue?vue&type=template&id=26995d88&scoped=true&ts=true"
import script from "./RegisterPage.vue?vue&type=script&lang=ts"
export * from "./RegisterPage.vue?vue&type=script&lang=ts"

import "./RegisterPage.vue?vue&type=style&index=0&id=26995d88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26995d88"]])

export default __exports__